import { render, staticRenderFns } from "./PropertyValue.vue?vue&type=template&id=e719ada0&"
import script from "./PropertyValue.vue?vue&type=script&lang=ts&"
export * from "./PropertyValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports